import https from '../init/https';
import supHttps from '../init/supHttps';
import orgHttps from '../init/orgHttps';

//ANALYTICS-01 : Track a single analytics event (page view, search, trip view, booking step, payment step)
export async function addAnalytics(data) {
    const result = await https.post('/analytics/event', data);

    return result;
}

//ANALYTICS-02 : Get the logged-in user's recent searches and recently viewed trips
export async function getMyRecent(type = 'trip') {
    const result = await https.get('/analytics/my-recent', {
        params: {
            type
        }
    });

    return result;
}

//ANALYTICS-03 : Support-admin analytics overview (users, sessions, searches, trip views, funnel, daily activity) - platform-wide
export async function getAnalytics({ from, to } = {}) {
    try {
        const result = await supHttps.get('/analytics/summary', {
            params: {
                from,
                to
            }
        });

        return result;
    } catch (error) {
        console.log('Analytics error data:', error?.response?.data);

        throw error;
    }
}

//ANALYTICS-04 : Support-admin analytics details (most viewed trips, top destinations, popular trip types) - platform-wide
export async function getAnalyticsDetails({ from, to } = {}) {
    const result = await supHttps.get('/analytics/details', {
        params: {
            from,
            to
        }
    });

    return result;
}

//ANALYTICS-05 : Support-admin users/visitors list with activity summary - platform-wide
export async function getAnalyticsUsers({ from, to, limit, offset } = {}) {
    const result = await supHttps.get('/analytics/users', {
        params: {
            from,
            to,
            limit,
            offset
        }
    });

    return result;
}

//ANALYTICS-06 : Support-admin single user/visitor journey timeline - platform-wide
export async function getAnalyticsUserDetails({ id, type = 'user', from, to } = {}) {
    const result = await supHttps.get(`/analytics/user/${id}`, {
        params: {
            type,
            from,
            to
        }
    });

    return result;
}

//ORG-TRIP-40 : Organizer analytics overview, scoped to this organizer's own trips
export async function getOrgAnalytics({ from, to } = {}) {
    const result = await orgHttps.get('/org/trip/analytics/summary', {
        params: {
            from,
            to
        }
    });

    return result;
}

//ORG-TRIP-41 : Organizer analytics details (most viewed trips), scoped to this organizer's own trips
export async function getOrgAnalyticsDetails({ from, to } = {}) {
    const result = await orgHttps.get('/org/trip/analytics/details', {
        params: {
            from,
            to
        }
    });

    return result;
}

//ORG-TRIP-42 : Organizer users/visitors list, scoped to people who interacted with this organizer's own trips
export async function getOrgAnalyticsUsers({ from, to, limit, offset } = {}) {
    const result = await orgHttps.get('/org/trip/analytics/users', {
        params: {
            from,
            to,
            limit,
            offset
        }
    });

    return result;
}

//ORG-TRIP-43 : Organizer single user/visitor journey, scoped to that person's activity on this organizer's own trips
export async function getOrgAnalyticsUserDetails({ id, type = 'user', from, to } = {}) {
    const result = await orgHttps.get(`/org/trip/analytics/user/${id}`, {
        params: {
            type,
            from,
            to
        }
    });

    return result;
}
